import React from 'react';

interface LineInCircleIconProps {
  size?: number;
}

const LineInCircleIcon: React.FC<LineInCircleIconProps> = ({ size = 24 }) => (
  <svg width={size} viewBox="0 0 24 24" version="1.1" fill="none">
    <path
      d="M15,11.4 L8,11.4 M11.5,22.5 C17.5751322,22.5 22.5,17.5751322 22.5,11.5 C22.5,5.42486775 17.5751322,0.5 11.5,0.5 C5.42486775,0.5 0.5,5.42486775 0.5,11.5 C0.5,17.5751322 5.42486775,22.5 11.5,22.5 Z"
      stroke="currentColor"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    />
  </svg>
);

export default LineInCircleIcon;
